import { Link, useLocation } from 'react-router-dom'
import { Bot, Clock, HelpCircle, Headphones, ScrollText, Wallet } from 'lucide-react'

export interface BotSettingsNavTabItem {
  name: string
  path: string
  icon: React.ComponentType<{ className?: string }>
  description?: string
}

export const BOT_SETTINGS_NAV_TABS: BotSettingsNavTabItem[] = [
  { name: 'General y Prompt', path: '/app/bot-settings', icon: Bot, description: 'Personalidad, modelo y checkout' },
  { name: 'Horarios de atención', path: '/app/bot-settings/advanced', icon: Clock, description: 'Disponibilidad y fuera de horario' },
  { name: 'Preguntas Frecuentes', path: '/app/bot-settings/faq', icon: HelpCircle, description: 'Base de conocimiento y puente FAQ' },
  { name: 'Pagos', path: '/app/bot-settings/payments', icon: Wallet, description: 'Métodos de pago y datos bancarios' },
  { name: 'Escalamiento', path: '/app/bot-settings/escalation', icon: Headphones, description: 'Derivación a asesores humanos' },
  { name: 'Reglas propias', path: '/app/bot-settings/rules', icon: ScrollText, description: 'Opción avanzada: indicaciones de tu negocio' },
]

interface BotSettingsNavTabsProps {
  className?: string
}

export default function BotSettingsNavTabs({ className }: BotSettingsNavTabsProps) {
  const location = useLocation()

  return (
    <div
      data-testid="bot-settings-nav-tabs"
      className={`border-b border-slate-200 bg-white/90 backdrop-blur px-3 py-2 sm:px-4 sm:rounded-2xl sm:border sm:shadow-sm mb-5 ${className || ''}`}
    >
      <div className="flex items-center justify-between gap-3">
        <nav
          className="flex space-x-1.5 sm:space-x-2 overflow-x-auto py-0.5 scrollbar-none w-full"
          aria-label="Submenú de Configuración de IA"
        >
          {BOT_SETTINGS_NAV_TABS.map((tab) => {
            const Icon = tab.icon
            const isActive =
              location.pathname === tab.path ||
              (tab.path !== '/app/bot-settings' && location.pathname.startsWith(`${tab.path}/`))

            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={[
                  'flex items-center gap-2 whitespace-nowrap rounded-xl px-3 py-2 text-xs sm:text-sm font-semibold transition-all',
                  isActive
                    ? 'bg-[#075f55] text-white shadow-sm'
                    : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900',
                ].join(' ')}
                title={tab.description}
              >
                <Icon className={`h-4 w-4 ${isActive ? 'text-white' : 'text-slate-500'}`} />
                <span>{tab.name}</span>
              </Link>
            )
          })}
        </nav>
      </div>
    </div>
  )
}
